
import { Box, ListItem, Menu, styled, Typography, } from '@mui/material';
import { StyleguideSavioColors, StyleguideSavioFonts } from '../../../configuration/themeSettings';

export const MenuStyled = styled(Menu, {
    label: "MoreOrderInfoComponent-MenuStyledx ",
})(({ theme }) => ({

}
));

export const MenuItemStyled = styled(ListItem, {
    label: "MoreOrderInfoComponent-MenuItemStyled ",
})(({ theme }) => ({
    color: 'red',
    padding: '9px 16px',
    height: 48,
    borderBottom: '1px solid ' + StyleguideSavioColors.lightGrey,
    position: 'relative',

    'h6': {
        color: StyleguideSavioColors.text.black,
        fontSize: 14,
        margin: 0,
    },
    '&:hover': {
        backgroundColor: 'inherit',
        cursor: "pointer",
        '&:before': {
            content: '""',
            display: 'block',
            width: 3,
            height: '100%',
            backgroundColor: StyleguideSavioColors.blue,
            position: 'absolute',
            left: 0,
        },
        'h6': {
            color: StyleguideSavioColors.blue, textDecoration: 'underline',

        }
    }
}
));

export const BoxRowStyled = styled(Box, {
    label: "MoreOrderInfoComponent-BoxRowStyled ",
})(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: 27,
}
));

export const LabelStyled = styled(Typography, {
    label: "MoreOrderInfoComponent-LabelStyled ",
})(({ theme }) => ({
    fontWeight: StyleguideSavioFonts.bold,
    textTransform: 'uppercase',
    fontSize: 14,
    '&:after': {
        content: '":"',
    }
}
));

export const ValueStyled = styled(Typography, {
    label: "MoreOrderInfoComponent-ValueStyled ",
})(({ theme }) => ({
    fontSize: 14,
    paddingLeft: 10,
}
));
